import { publishMessageToParentApp } from './utils';
import { PARENT_APP_IFRAME_ID } from './consts';

const scrollIntoFrameViewHandler = () => {
  return `
    const iframe = parentDocument.getElementById('${PARENT_APP_IFRAME_ID}');
    iframe.style.scrollMarginTop = '100px';
     iframe.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
     })
  `;
};

export const scrollIntoFrameView = () => {
  publishMessageToParentApp(scrollIntoFrameViewHandler());
};
